<template>
    <v-row class="mt-2">
        <v-col cols="3">
            <v-treeview
                :items="sections"
                :itemOpen.sync="itemOpen"
                :active.sync="activeNodes"
                :open.sync="openNodes"
                expand-icon=""
                color="primary-light"
                activatable
                :calculate-width="true"
                :open-all="true"
                class="style-tree scroll-y"
                active-class="deep-orange--text text--darken-4"
                @update:active="previewItem(activeNodes[0]); openNodes.push($event.id)"
                :loading="loading"
                :style="{ 'height': `${$vuetify.breakpoint.height - 90}px` }"
                @change="getParent()"
                :disabled="loading"
            >
                <template v-slot:prepend="{ item, open }">
                    <v-icon
                        v-if="item.children && item.children.length"
                        class="mx-0"
                        @click="(() => {
                            if(open) {
                                openNodes.splice(openNodes.indexOf(item.id), 1)
                            } else{ 
                                openNodes.push(item.id)
                            }

                        })"
                        :disabled="loading"
                    >   
                        {{open ? 'mdi-minus' : 'mdi-plus'}}
                    </v-icon>
                </template>
            </v-treeview>
        </v-col>

        <v-col v-if="$route.params.id" cols="9">
            <v-spacer />
            <v-btn
                color="success white--text"
                small
                class="mb-1"
                @click="submitConfig()"
                :loading="loading"
            >
                <v-icon small class="pe-1"> {{ $route.query.configId ? 'mdi-pencil' : 'mdi-content-save' }} </v-icon>
                {{ $route.query.configId ? $t('save') : $t('add')}}
            </v-btn>

            <bee-handy-table       
                ref="table" 
                :headers="headers"
                :items="items"
                dense
                zebra
                hide-default-footer
                :items-per-page="-1"
                :height="$vuetify.breakpoint.height - 110"
                table-class="rounded-lg"
                fixed-header
                :loading="loading"
            >
                <template v-slot:item.booleanValue="{ item }">
                    <div class="d-flex">
                        <v-switch
                            v-model="item.booleanValue" 
                            hide-details
                            class="mt-0"
                            :disabled="loading"
                        ></v-switch>
                    </div>
                </template>
            </bee-handy-table>
        </v-col>

        <v-col
            v-else
            cols="9"
            class="d-flex flex-column justify-center align-center"
            :style="{ height: `${$vuetify.breakpoint.height - 90}px` }"
        >
            <v-progress-circular
                v-if="loading"
                color="primary"
                indeterminate
                size="44"
                width="4"
            />
            <template v-else>
                <v-icon size="60" class="mb-1">mdi-account-cog</v-icon>
                <span class="text-h6">{{$t('Settings.please-select-a-section')}}</span>
            </template>
        </v-col>
    </v-row>
</template>

<script>
import { mapState } from 'vuex'
import { fieldsInStaff, fieldsInStaffRole, fieldsInCustomers, fieldsInMaterials, fieldsVisits, fieldsInCustomersType } from '@/helpers/enums'
export default {
    data () {
        return {
            // centerNotes 3
            // doctorNames 18
            key: 0,
            section: 0,

            customerType: null,

            fieldsInStaff,
            fieldsInStaffRole,
            fieldsInCustomers,
            fieldsInMaterials,
            fieldsVisits,
            fieldsInCustomersType,
 
            // itemsStaff: [
            //     {
            //         name: this.$t('Settings.phone-number'),
            //         permissionEnum: fieldsInStaff.phoneNumber,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.landline-number'),
            //         permissionEnum: fieldsInStaff.landlineNumber,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.address'),
            //         permissionEnum: fieldsInStaff.address,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.email'),
            //         permissionEnum: fieldsInStaff.email,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.job-position'),
            //         permissionEnum: fieldsInStaff.jobPosition,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.facebook-profile-url'),
            //         permissionEnum: fieldsInStaff.facebookProfileUrl,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.starting-date'),
            //         permissionEnum: fieldsInStaff.startingDate,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.line-manager'),
            //         permissionEnum: fieldsInStaff.lineManagerId,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.role'),
            //         permissionEnum: fieldsInStaff.roleId,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.gender'),
            //         permissionEnum: fieldsInStaff.gender,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.regions'),
            //         permissionEnum: fieldsInStaff.regionIds,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.specialty'),
            //         permissionEnum: fieldsInStaff.specialtyIds,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.team'),
            //         permissionEnum: fieldsInStaff.teamId,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.leave-days-number'),
            //         permissionEnum: fieldsInStaff.leaveDaysNumber,
            //         booleanValue: false,
            //     },
            //     {
            //         name: this.$t('Settings.username'),
            //         permissionEnum: fieldsInStaff.username,
            //         booleanValue: false,
            //     },
            //     {
            //         name: this.$t('Settings.password'),
            //         permissionEnum: fieldsInStaff.password,
            //         booleanValue: false,
            //     },
            //     {
            //         name: this.$t('Settings.certificate'),
            //         permissionEnum: fieldsInStaff.certificate,
            //         booleanValue: false,
            //     },
            //     {
            //         name: this.$t('Settings.target-value'),
            //         permissionEnum: fieldsInStaff.targetValue,
            //         booleanValue: false,
            //     },
            //     {
            //         name: this.$t('Settings.financial-target-value'),
            //         permissionEnum: fieldsInStaff.financialTargetValue,
            //         booleanValue: false,
            //     },
            //     {
            //         name: this.$t('Settings.employee-type'),
            //         permissionEnum: fieldsInStaff.employeeType,
            //         booleanValue: false,
            //     }

            // ],

            // itemsCustomers: [
            //     {
            //         name: this.$t('Settings.name'),
            //         permissionEnum: fieldsInCustomers.name,
            //         booleanValue: false,
                 
            //     },
            //     {
            //         name: this.$t('Settings.type'),
            //         permissionEnum: fieldsInCustomers.type,
            //         booleanValue: false,
                 
            //     },
            //     // delete it when drop enum entity
            //     // {
            //     //     name: this.$t('Settings.entity-type'),
            //     //     permissionEnum: fieldsInCustomers.entityType,
            //     //     booleanValue: false,
                 
            //     // },
                
            //     {
            //         name: this.$t('Settings.best-time-to-visit'),
            //         permissionEnum: fieldsInCustomers.bestTimeToVisit,
            //         booleanValue: false,
                 
            //     },
            //     {
            //         name: this.$t('Settings.opening-time'),
            //         permissionEnum: fieldsInCustomers.openingTime,
            //         booleanValue: false,
                 
            //     },
            //     {
            //         name: this.$t('Settings.closing-time'),
            //         permissionEnum: fieldsInCustomers.closingTime,
            //         booleanValue: false,
                 
            //     },
            //     {
            //         name: this.$t('Settings.contact-info'),
            //         permissionEnum: fieldsInCustomers.contactInfo,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.address'),
            //         permissionEnum: fieldsInCustomers.address,
            //         booleanValue: false
            //     },  
            //     {
            //         name: this.$t('Settings.loyalty'),
            //         permissionEnum: fieldsInCustomers.loyalty,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.weekend'),
            //         permissionEnum: fieldsInCustomers.weekend,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.work-hours-to'),
            //         permissionEnum: fieldsInCustomers.workHoursTo,
            //         booleanValue: false,
                 
            //     },
            //     {
            //         name: this.$t('Settings.work-hours-from'),
            //         permissionEnum: fieldsInCustomers.workHoursFrom,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.next-visit-notes'),
            //         permissionEnum: fieldsInCustomers.visitNotes,
            //         booleanValue: false
            //     }
            // ],

            // itemsVisits: [
            //     {
            //         name: this.$t('Settings.entity'),
            //         permissionEnum: fieldsVisits.entityId,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.free-sample'),
            //         permissionEnum: fieldsVisits.freeSample,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.other-samples'),
            //         permissionEnum: fieldsVisits.otherSamples,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.notes'),
            //         permissionEnum: fieldsVisits.notes,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.objections'),
            //         permissionEnum: fieldsVisits.objections,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.next-visit-notes'),
            //         permissionEnum: fieldsVisits.nextVisitNotes,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.purpose'),
            //         permissionEnum: fieldsVisits.purpose,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.material-amounts'),
            //         permissionEnum: fieldsVisits.materialAmounts,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.unavailable-material'),
            //         permissionEnum: fieldsVisits.unavailableMaterialIds,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.competitive-samples'),
            //         permissionEnum: fieldsVisits.competitiveSamples,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.core-message'),
            //         permissionEnum: fieldsVisits.coreMessage,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.longitude'),
            //         permissionEnum: fieldsVisits.longitude,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.latitude'),
            //         permissionEnum: fieldsVisits.latitude,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.duration-in-minutes'),
            //         permissionEnum: fieldsVisits.durationInMinutes,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.amount-received'),
            //         permissionEnum: fieldsVisits.amountReceived,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.resident-doctor-names'),
            //         permissionEnum: fieldsVisits.residentDoctorNames,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.payment'),
            //         permissionEnum: fieldsVisits.payment,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.price-type'),
            //         permissionEnum: fieldsVisits.priceTypeId,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.specialty'),
            //         permissionEnum: fieldsVisits.specialtyId,
            //         booleanValue: false
            //     },
                
            // ],

            // itemsMaterials: [
            //     {
            //         name: this.$t('Settings.number'),
            //         permissionEnum: fieldsInMaterials.number,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.name'),
            //         permissionEnum: fieldsInMaterials.name,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.material-form'),
            //         permissionEnum: fieldsInMaterials.materialFormId,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.description'),
            //         permissionEnum: fieldsInMaterials.description,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.dose'),
            //         permissionEnum: fieldsInMaterials.dose,
            //         booleanValue: false,
            //     },
            //     {
            //         name: this.$t('Settings.strength'),
            //         permissionEnum: fieldsInMaterials.strength,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.pills-per-box'),
            //         permissionEnum: fieldsInMaterials.pillsPerBox,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.price'),
            //         permissionEnum: fieldsInMaterials.price,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.leaflet-file-path'),
            //         permissionEnum: fieldsInMaterials.leafletFilePath,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.specialty'),
            //         permissionEnum: fieldsInMaterials.specialty,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.min-amount'),
            //         permissionEnum: fieldsInMaterials.minAmount,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.max-amount'),
            //         permissionEnum: fieldsInMaterials.maxAmount,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.composition-per-unit'),
            //         permissionEnum: fieldsInMaterials.compositionPerUnit,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.pharmacies-price'),
            //         permissionEnum: fieldsInMaterials.pharmaciesPrice,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.price-types'),
            //         permissionEnum: fieldsInMaterials.priceTypes,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.price-discount-rate'),
            //         permissionEnum: fieldsInMaterials.priceDiscountRate,
            //         booleanValue: false
            //     }
            // ],
            itemsCustomersType: [
                {
                    name: this.$t('Settings.specialty'),
                    permissionEnum: fieldsInCustomersType.specialty,
                    booleanValue: false
                },
                {
                    name: this.$t('Settings.resident-doctor-names'),
                    permissionEnum: fieldsInCustomersType.residentDoctorNames,
                    booleanValue: false
                },
                {
                    name: this.$t('Settings.religion'),
                    permissionEnum: fieldsInCustomersType.religion,
                    booleanValue: false
                
                },
                {
                    name: this.$t('Settings.personality'),
                    permissionEnum: fieldsInCustomersType.personality,
                    booleanValue: false
                
                },
                {
                    name: this.$t('Settings.birthdate'),
                    permissionEnum: fieldsInCustomersType.birthdate,
                    booleanValue: false
                },
                {
                    name: this.$t('Settings.personal-note'),
                    permissionEnum: fieldsInCustomersType.personalNote,
                    booleanValue: false
                },
                {
                    name: this.$t('Settings.doctor-hobbies'),
                    permissionEnum: fieldsInCustomersType.doctorHobbies,
                    booleanValue: false
                
                },
                {
                    name: this.$t('Settings.near-by-pharmacies'),
                    permissionEnum: fieldsInCustomersType.nearByPharmacies,
                    booleanValue: false
                },
                {
                    name: this.$t('Settings.works-in-centers'),
                    permissionEnum: fieldsInCustomersType.worksInCenters,
                    booleanValue: false
                
                },
                {
                    name: this.$t('Settings.pharmacist-info'),
                    permissionEnum: fieldsInCustomersType.pharmacistInfo,
                    booleanValue: false
                },
                {
                    name: this.$t('Settings.pharmacy-info'),
                    permissionEnum: fieldsInCustomersType.pharmacyInfo,
                    booleanValue: false
                },
                {
                    name: this.$t('Settings.classification'),
                    permissionEnum: fieldsInCustomersType.classification,
                    booleanValue: false             
                }
            ],

            itemStaffRoles: [
                {
                    name: this.$t('Settings.landline-number'),
                    permissionEnum: fieldsInStaffRole.landlineNumber,
                    booleanValue: true
                },
                {
                    name: this.$t('Settings.email'),
                    permissionEnum: fieldsInStaffRole.email,
                    booleanValue: true
                },
                {
                    name: this.$t('Settings.facebook-profile-url'),
                    permissionEnum: fieldsInStaffRole.facebookProfileUrl,
                    booleanValue: true
                },
                {
                    name: this.$t('Settings.gender'),
                    permissionEnum: fieldsInStaffRole.gender,
                    booleanValue: true
                },
                {
                    name: this.$t('Settings.leave-days-number'),
                    permissionEnum: fieldsInStaffRole.leaveDaysNumber,
                    booleanValue: true
                },
                {
                    name: this.$t('Settings.certificate'),
                    permissionEnum: fieldsInStaffRole.certificate,
                    booleanValue: true
                },
                {
                    name: this.$t('Settings.target-value'),
                    permissionEnum: fieldsInStaffRole.targetValue,
                    booleanValue: true
                },
                {
                    name: this.$t('Settings.financial-target-value'),
                    permissionEnum: fieldsInStaffRole.financialTargetValue,
                    booleanValue: true
                }
            ],
            // items: [
            //     {
            //         name: this.$t('Settings.loyalty'),
            //         permissionEnum: 0,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.religion'),
            //         permissionEnum: 1,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.personality'),
            //         permissionEnum: 2,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.birthdate-client'),
            //         permissionEnum: 3,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.weekend'),
            //         permissionEnum: 4,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.near-by-pharmacies'),
            //         permissionEnum: 5,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.near-by-pharmacies-two'),
            //         permissionEnum: 6,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.works-in-centers'),
            //         permissionEnum: 7,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.work-hour-from'),
            //         permissionEnum: 8,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.work-hour-to'),
            //         permissionEnum: 9,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.doctor-hobbies'),
            //         permissionEnum: 10,
            //         booleanValue: false
            //     },
            //     {
            //         name: this.$t('Settings.visit-notes'),
            //         permissionEnum: 11,
            //         booleanValue: false
            //     }
            // ],

            itemOpen: 10000,
			activeNodes: [0],
			openNodes: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            loading: false,
            sectionsFlat: [],
            parent: null,
            items: []
        }
    },

	computed: {
		...mapState({
			customersTypes: state => state.entityType.customersTypes,
            permissionArray: state => state.entityType.permissionArray,
            userLoginEmployeeId: state => state.auth.self.employeeId,
            roles: state => state.rolePermission.roles,
            conItems: state => state.configuration.staffConfig,
            itemsStaff: state => state.configuration.fieldsInStaff,
            itemsCustomers: state => state.configuration.fieldsInCustomers,
            itemsMaterials: state => state.configuration.fieldsInMaterials,
            itemsVisits: state => state.configuration.fieldsVisits,
            configuration: state => state.configuration.allConfigurations
		}),

        headers () {
            return [
                {
                    text: this.$t('headers.name'),
                    name: 'name',
                    value: 'name',
                    width: '65%',
                    sortable: false
                },
                {
                    text: this.$t('headers.actions'),
                    name: 'booleanValue',
                    value: 'booleanValue',
                    columnClass: 'text-center',
                    sortable: false
                }
            ]
        },

        sections () {
            return [
                {
                    name: 'Staff',
                    id: 1,
                    key: null,
                    children: this.roles.map(c => ({ 
                        ...c,
                        parentId: 0, 
                        parent: 'Staff',
                        section: 1,
                        configId: null,
                        items: this.itemStaffRoles,
                        key: c.id,
                    })),
                    parent: 'ParentStaff',
                    items: this.itemsStaff,
                    configId: null
                },
                {
                    name: 'Customers',
                    id: 2,
                    key: null,
                    children: this.customersTypes.map(c => ({ 
                        ...c, 
                        parentId: 1, 
                        parent: 'Customers',
                        section: 2,
                        configId: null,
                        items: this.itemsCustomersType,
                        key: c.id,
                    })),
                    parent: 'ParentCustomers',
                    items: this.itemsCustomers,
                    configId: null
                },
                {
                    name: 'Materials',
                    id: 3,
                    key: null,
                    children: [],
                    parent: 'ParentMaterials',
                    items: this.itemsMaterials,
                    configId: null
                },
                {
                    name: 'Visits',
                    id: 4,
                    key: null,
                    children: [],
                    parent: 'ParentVisits',
                    items: this.itemsVisits,
                    configId: null
                }
            ]
        }
        
	},

    methods: {
        getAllConfig () {
            return this.$store.dispatch('configuration/fetchAll').then((data) => {
                // this.configuration = data
                this.sectionsFlat = this.flattenRoles(this.sections)
            })
        },

        previewItem (id) {
            const conf = Number.isInteger(id) ? this.configuration.find(c => c.section === id) : this.configuration.find(c => c.key === id)
            this.$router.replace({
                params: {
                    id: id, // if number is Parent or is id "String" is child
                    section: Number.isInteger(id) ? this.configuration.find(c => c.section === id)?.section : this.configuration.find(c => c.key === id)?.section, // for know child for any parent ?
                    parent: this.sectionsFlat.find(c => c.id === id)?.parent
                },
                query: {
                    configId:  Number.isInteger(id) ? this.configuration.find(c => c.section === id)?.configId : this.configuration.find(c => c.key === id)?.configId,
                }
            })
            console.log('configuration', this.configuration)
            console.log('conf', conf)
            this.items = conf?.data.map(c => ({
                booleanValue: c.booleanValue,
                isMain: c.isMain,
                key: c.key,
                name: c.name,
                value: c.value
            }))

            this.items = conf?.data
            console.log('items', this.items)
        },
        
        flattenRoles(tree) {
            let flatArray = [];
            for (const item of tree) {
                flatArray.push(item);
                if (item.children && item.children.length > 0) {
                    flatArray = flatArray.concat(this.flattenRoles(item.children));
                }
            }
            return flatArray;
        },

        submitConfig () {
            this.loading = true
            const actionName = this.$route.query.configId ? 'update' : 'create'
            this.$store.dispatch(`configuration/${actionName}`, { 
                id: this.$route.query.configId,
                section: Number.isInteger(this.$route.params.id) ? +this.$route.params.id : +this.$route.params.section,
                // section: Number.isInteger(this.$route.params.id) ? this.$route.params.id : this.sections.find(c => c.name === this.$route.params.parent)?.id,
                key: Number.isInteger(this.$route.params.id) ? null : (this.$route.params.id).toString(),
                values: this.items.map((value, index) => value.booleanValue ? value.value : -1).filter(index => index !== -1).join(', ')
            }).then(() => {
                this.getAllConfig().finally(() => {
                    this.loading = false
                })
            })
        }
    },

    created () {
        this.loading = true
        Promise.all([
            this.$store.dispatch('rolePermission/fetchChildrenRole', { 
                id: this.userLoginEmployeeId
            }),
            // !this.customersTypes.length ? this.$store.dispatch('entityType/fetchAll').then(() => {
            //     // this.customerType = this.customersTypes[0].id
            // }) : null,
            // !this.conItems.length ? this.$store.dispatch('configuration/fetchAll') : null
        ]).then(() => {
            // this.getAllConfig()
        }).finally(() => {
            this.loading = false
        })
    }
}
</script>

<style lang="scss">
@import url('../../scss/variables.scss');
.scroll-y {
    overflow-y: auto
}
.style-tree {
    background: #118aa825;
    border-radius: 10px;
}
</style>
